import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import ProductWidget from './ProductWidget';
import Text from '../../../refresh/atoms/Text';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getProductsDetails, getDynamicProductsDetails,  getCuratedProductsDetails } from '../../../actions/bannerProducts';
import * as actions from '../../../actions/productData';
import { getBannerProducts } from '../../../refresh/selectors/banner';
import { productDataFormatter } from '../../../utils/productWidget';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { signInCheck } from '../../common/CheckUserStatus';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import CuratedWidget from './CuratedWidget';
import { getCookie } from '../../common/Cookie';
import RecentlyViewed from './RecentlyViewed';

const ProductWidgetContainer = ({
  banners,
  componentName,
  heading,
  rowNumber,
  subHeading,
  bgColor,
  newDesignLuxe,
  loadingBannerProducts,
  productsData = [],
  errorWhileLoadingData,
  priceRevealMetaInfoProductWidget,
  getProductsDetails,
  getDynamicProductsDetails,
  platform = '',
  dynamicProductWidgetUrl,
  getCuratedProductsDetails,
  getRecentlyViewedProductsDetails,
  recentlyViewed,
  recentlyViewedProduct,
}) => {
  const [productIdCount, setProductIdCount] = useState(0);
  const [productIdList, setProductIdList] = useState('');
  const [displayProductWidget, setDisplayProductWidget] = useState(true);
  const [productsToDisplay, setProductsToDisplay] = useState([]);
  const productIds = banners.products;
  const [isDynamicProductList, setIsDynamicProductList] = useState(false);
  const [shouldShowSalePrice, setShouldShowSalePrice] = useState(false);
  const { bannerType = '', ctaSettings = {}, widgetLevel = '', feedLogic = '' } = banners;
  const isDynamicProductWidget = bannerType === 'DYNAMIC_WIDGET';
  const isCuratedProductWidget = bannerType === 'CURATED_WIDGET';
  const isRecentlyViewedProductWidget = bannerType === 'RECENTLY_VIEWED';
  const productIdsWithSequence = [];
  for (const product of productIds) {
    const { productId, sequence } = product || {};
    productIdsWithSequence[sequence - 1] = productId;
  }

  const recentlyViewedProductData = Object.keys(recentlyViewedProduct).length === 0 ? '' : recentlyViewedProduct;

  let recentlyViewedProductIds = [];
  if (signInCheck()) {
  const cookie = getCookie('recentlyViewed');
  if (cookie) {
    recentlyViewedProductIds = (JSON.parse(cookie) || []).map(x => x.id);
  }
}

  useEffect(() => {
    if (productIds.length < 4 && !isDynamicProductWidget) {
      setDisplayProductWidget(false);
    }
  }, [productIds]);

  useEffect(() => {
    if (productIds.length > 0) {
      const firstProductId = productIds[0].productId;
      if (firstProductId) {
        setProductIdCount(initial => initial + 1);
      }
      const updatedProductsList = productIds.slice(1, productIds.length + 1);
      const productList = updatedProductsList.reduce((productIdList, eachProductId) => {
        setProductIdCount(initial => initial + 1);
        return `${productIdList},${eachProductId.productId}`;
      }, firstProductId);
      setProductIdList(productList);
    }
  }, [productIds]);

  useEffect(() => {
    if (productIdCount >= 4 && productIdList !== '' && productsData.length === 0) {
      getProductsDetails(productIdList);
    }
  }, [productIdCount, productIdList]);

  useEffect(() => {
    if (errorWhileLoadingData) {
      setDisplayProductWidget(false);
    }
  }, [errorWhileLoadingData]);

  useEffect(() => {
    if (productsData.length > 0) {
      let productsToDisplay = productsData;
      if (!isDynamicProductWidget) {
        productsToDisplay = productsToDisplay.filter(eachProduct => eachProduct.inStockFlag);
        if (productsToDisplay.length < 4) {
          setDisplayProductWidget(false);
          return; // Exit early to avoid further state changes
        }
      }
      const formattedProducts = productDataFormatter(productsToDisplay);
      formattedProducts.sort(
        (a, b) =>
          productIdsWithSequence.indexOf(a.productColor) -
          productIdsWithSequence.indexOf(b.productColor)
      );
      setProductsToDisplay(formattedProducts);
    }

    if (isDynamicProductWidget) {
      if (isDynamicProductList) {
        setDisplayProductWidget(productsData.length >= 4);
      } else if (productsData.length === 0) {
        setIsDynamicProductList(true);
        getDynamicProductsDetails({ heading, platform }, banners, false);
        setDisplayProductWidget(true);
      }
    }

    if (isCuratedProductWidget) {
      if (isDynamicProductList) {
        setDisplayProductWidget(productsData.length >= 4);
      } else if (productsData.length === 0) {
        setIsDynamicProductList(true);
        getCuratedProductsDetails({ heading }, banners, false);
        setDisplayProductWidget(true);
      }
    }

    if (recentlyViewedProductIds.length > 0 && isRecentlyViewedProductWidget) {
      if (isDynamicProductList) {
        setDisplayProductWidget(productsData.length >= 4);
      } else if (productsData.length === 0) {
        setIsDynamicProductList(true);
        getRecentlyViewedProductsDetails(recentlyViewedProductIds.toString());
        setDisplayProductWidget(true);
      }
    }
  }, [productsData]);

  useEffect(() => {
    const username = signInCheck();
    if (username && localStorage.getItem('priceReveal_v2')) {
      setShouldShowSalePrice(true);
    }
  }, []);

  const viewShowMoreProducts = () => {
    if (dynamicProductWidgetUrl?.length > 0) {
      gtmEventPush({
        event:
          banners.widgetLevel.toLowerCase() === 'user'
            ? 'user_level_widget_interactions'
            : 'dynamic_widget_interactions',
        eventCategory:
          banners.widgetLevel.toLowerCase() === 'user'
            ? 'user_level widget interactions'
            : 'Dynamic widget interactions',
        eventAction: 'explore all click'
      });
      dynamicProductWidgetRedirection(dynamicProductWidgetUrl, true);
    }
  };

  const dynamicProductWidgetRedirection = (url, isViewMore = false) => {
    if (isViewMore && url?.length > 0) {
      if (url.includes('?')) {
        url = `${url}&`;
      } else {
        const consitsSlash = url.charAt(url.length - 1) === '/';
        url = consitsSlash ? `${url}?` : `${url}/?`;
      }
      const params = {
        isDynamicWidget: true,
        heading,
        widgetLevel,
        feedLogic
      };
      if (banners.showDefault !== undefined) {
        params.showDefaultIfNoData = banners.showDefault;
      }
      const deeplink = `${url}${qs.stringify(params)}`;

      window.location = deeplink;
    } else {
      window.location = url;
    }
  };

  function eventPush({ eventName, ...rest }) {
    let { landing: { screenType = '', screenName = '' } = {} } = luxeScreen;
    let eventPushObj = {
      user_details: {
        store_type: newDesignLuxe ? 'luxe' : 'ajio',
        user_status: signInCheck() ? 'logged in' : 'not logged In',
        time_of_the_day: '',
        login_type: signInCheck() ? 'logged in' : 'not logged In',
        screen_name: '',
        screen_type: screenType
      }
    };
    gtmEventPush({
      event: eventName,
      ...rest,
      ...eventPushObj.user_details
    });
  }

  if ((productsData?.length < 4  && !isRecentlyViewedProductWidget) || errorWhileLoadingData) {
    return <div />;
  }

  if(isCuratedProductWidget && (Object.keys(productsData).length === 0 ||  productsData?.curatedWidgetItemList && productsData?.curatedWidgetItemList.length === 0)){
    return null;
  }

  return (
    <div className="product-widget-section" style={{ backgroundColor: bgColor || '#fff' }}>
      {(heading || subHeading) && (
        <HeadingComponent
          heading={heading}
          subHeading={subHeading}
          isCuratedProductWidget={isCuratedProductWidget}
          isLoading={loadingBannerProducts && productsToDisplay.length === 0}
        />
      )}
      {loadingBannerProducts && productsToDisplay.length === 0  ? (
        <DesktopProductWidgetShimmer
          luxe={newDesignLuxe}
          isCuratedProductWidget={isCuratedProductWidget}
          isLoading={loadingBannerProducts && productsToDisplay.length === 0}
        />
      ) : isCuratedProductWidget ? (
        <CuratedWidget
          isLoading={loadingBannerProducts && productsToDisplay.length === 0}
          banners={banners}
          curatedWidgetData={productsData}
          products={[]}
          heading={heading}
          rowNumber={rowNumber}
          bannerType={bannerType}
          eventPush={eventPush}
          priceRevealMetaInfoProductWidget={priceRevealMetaInfoProductWidget}
          ctaSettings={ctaSettings}
          viewShowMoreProducts={viewShowMoreProducts}
          dynamicProductWidgetRedirection={dynamicProductWidgetRedirection}
        />
      ) : isRecentlyViewedProductWidget ? (
        <RecentlyViewed
          productIds={recentlyViewedProductIds}
          recentlyViewedList={recentlyViewed}
          isPriceReveal={shouldShowSalePrice}
          productData={recentlyViewedProductData}
          newDesignLuxe={newDesignLuxe}
          luxeEventPush={eventPush}
          isNewProductTag={false}
          ctaSettings={ctaSettings}
        />
      ) : (
        <ProductWidget
          banners={banners}
          products={productsToDisplay}
          componentName={componentName}
          heading={heading}
          rowNumber={rowNumber}
          eventPush={eventPush}
          priceRevealMetaInfoProductWidget={priceRevealMetaInfoProductWidget}
          isPriceReveal={shouldShowSalePrice}
          bannerType={bannerType}
          ctaSettings={ctaSettings}
          viewShowMoreProducts={viewShowMoreProducts}
          dynamicProductWidgetRedirection={dynamicProductWidgetRedirection}
        />
      )}
    </div>
  );
};

const HeadingComponent = ({ heading, subHeading, isCuratedProductWidget, isLoading }) => {

  if (isCuratedProductWidget && isLoading) {
    return null;
  }
  return (
    <div className="heading-container">
      {heading && <Text customClass="heading">{heading}</Text>}
      {subHeading && <Text customClass="sub-heading">{subHeading}</Text>}
    </div>
  );
};

const DesktopProductWidgetShimmer = ({ luxe, isCuratedProductWidget, isLoading }) => {
  const isCuratedProductWidgetLoading = isCuratedProductWidget && isLoading;

  return (
    <div
      className={`product-widget-shimmer-container ${
        isCuratedProductWidgetLoading ? 'curated_widget' : ''
      }`}
    >
      {!isCuratedProductWidgetLoading && <div className="shimmer-prev-arrow"> </div>}
      {isCuratedProductWidgetLoading && (
        <div className="curated_widget-heading__shimmer">
          <div className="curated_widget-heading ldr" />
          <div className="curated_widget-sub__heading ldr" />
        </div>
      )}
      <div className="products-container">
        <div>
          <div className="product-widget-image-shm ldr"> </div>
          <div
            className={
              luxe
                ? 'product-widget-details-container-shm-luxe'
                : 'product-widget-details-container-shm'
            }
          >
            <div className="product-widget-brand-shm ldr"> </div>
            <div
              className={`product-widget-description-shm ldr ${
                isCuratedProductWidgetLoading ? 'curated_widget' : ''
              }`}
            >
              {' '}
            </div>
            {!isCuratedProductWidgetLoading && (
              <div className="product-widget-price-shm ldr"> </div>
            )}
          </div>
        </div>
        <div>
          <div className="product-widget-image-shm ldr"> </div>
          <div
            className={
              luxe
                ? 'product-widget-details-container-shm-luxe'
                : 'product-widget-details-container-shm'
            }
          >
            <div className="product-widget-brand-shm ldr"> </div>
            <div
              className={`product-widget-description-shm ldr ${
                isCuratedProductWidgetLoading ? 'curated_widget' : ''
              }`}
            >
              {' '}
            </div>
            {!isCuratedProductWidgetLoading && (
              <div className="product-widget-price-shm ldr"> </div>
            )}
          </div>
        </div>
        <div>
          <div className="product-widget-image-shm ldr"> </div>
          <div
            className={
              luxe
                ? 'product-widget-details-container-shm-luxe'
                : 'product-widget-details-container-shm'
            }
          >
            <div className="product-widget-brand-shm ldr"> </div>
            <div
              className={`product-widget-description-shm ldr ${
                isCuratedProductWidgetLoading ? 'curated_widget' : ''
              }`}
            >
              {' '}
            </div>
            {!isCuratedProductWidgetLoading && (
              <div className="product-widget-price-shm ldr"> </div>
            )}
          </div>
        </div>
        <div>
          <div className="product-widget-image-shm ldr"> </div>
          <div
            className={
              luxe
                ? 'product-widget-details-container-shm-luxe'
                : 'product-widget-details-container-shm'
            }
          >
            <div className="product-widget-brand-shm ldr"> </div>
            <div className="product-widget-description-shm ldr"> </div>
            {!isCuratedProductWidgetLoading && (
              <div className="product-widget-price-shm ldr"> </div>
            )}
          </div>
        </div>
      </div>
      {!isCuratedProductWidgetLoading && <div className="shimmer-next-arrow"> </div>}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { flags = {} } = state;
  const storeName = getCurrentStore(state);
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const { loading, data, error } = getBannerProducts(state);
  const rowNumber = ownProps.rowNumber;
  return {
    newDesignLuxe,
    luxeFlags: getLuxeFlags(state.flags),
    currentStore: getCurrentStore(state),
    loadingBannerProducts: loading,
    productsData: data[`productWidget${rowNumber}`],
    errorWhileLoadingData: error,
    priceRevealMetaInfoProductWidget: data[`priceRevealMetaInfo productWidget${rowNumber}`],
    dynamicProductWidgetUrl: data[`redirectUrl productWidget${rowNumber}`],
    recentlyViewed: state?.recentlyViewed?.recent || [],
    recentlyViewedProduct: state?.product?.productDetails
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const rowNumber = ownProps.rowNumber;
  return {
    getProductsDetails: productIds => {
      dispatch(getProductsDetails(productIds, `productWidget${rowNumber}`));
    },
    getDynamicProductsDetails: (widgetDetails, bannerDetails, showViewAllWidget) => {
      dispatch(
        getDynamicProductsDetails(
          widgetDetails,
          bannerDetails,
          showViewAllWidget,
          `productWidget${rowNumber}`
        )
      );
    },
    getCuratedProductsDetails: (widgetDetails, bannerDetails) => {
      dispatch(
        getCuratedProductsDetails(widgetDetails, bannerDetails, `productWidget${rowNumber}`)
      );
    },
    getRecentlyViewedProductsDetails: productIds => dispatch(actions.getRecentlyViewed(productIds))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductWidgetContainer);
